import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const APP_ORIGIN = window.location.origin;

const FacebookCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const code = params.get('code');
    const error = params.get('error');
    const errorReason = params.get('error_reason');
    const errorDescription = params.get('error_description');

    const isPopup = Boolean(window.opener);

    console.log('Facebook callback received:', {
      code: code ? 'present' : 'missing',
      error,
      errorReason,
      errorDescription,
      isPopup,
    });

    if (code) {
      console.log('✅ Authorization code received, length:', code.length);
      handleSuccess({ code, isPopup, navigate });
    } else if (error) {
      const errorMessage = errorDescription || errorReason || error;
      console.error('❌ Facebook login error:', error, errorMessage);
      handleError({ error, errorMessage, isPopup, navigate });
    } else {
      // Neither code nor error present — shouldn't normally happen, but
      // avoid leaving the user stuck on a blank spinner forever.
      const errorMessage = 'No authorization code or error returned by Facebook.';
      console.error('❌', errorMessage);
      handleError({ error: 'missing_code', errorMessage, isPopup, navigate });
    }
  }, [navigate]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        backgroundColor: '#f8f9fa',
      }}
    >
      <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
      <p className="mt-3 h5">Completing Facebook login...</p>
      <p className="text-muted">Please wait while we authenticate</p>
    </div>
  );
};

function handleSuccess({ code, isPopup, navigate }) {
  if (isPopup) {
    // IMPORTANT: target origin must be the OPENER's origin (your main app),
    // not window.location.origin (which is this popup's own origin — e.g.
    // the ngrok tunnel host during local dev). Sending to the wrong target
    // origin makes the browser silently drop the message.
    window.opener.postMessage({ type: 'facebook_auth', code }, APP_ORIGIN);

    renderStatus({
      icon: '✓',
      iconColor: '#06d6a0',
      title: 'Login Successful!',
      message: 'You can close this window now.',
    });

    setTimeout(() => window.close(), 2000);
  } else {
    // Full-page redirect fallback (no popup). Just route within this tab —
    // whatever page receives this should exchange the code for a token.
    navigate('/setting/third-party/facebook', { state: { code } });
  }
}

function handleError({ error, errorMessage, isPopup, navigate }) {
  if (isPopup) {
    window.opener.postMessage(
      { type: 'facebook_auth', error, errorDescription: errorMessage },
      APP_ORIGIN
    );

    renderStatus({
      icon: '✗',
      iconColor: '#ef476f',
      title: 'Login Failed',
      message: errorMessage,
      showCloseButton: true,
    });
  } else {
    navigate('/setting/third-party/facebook', { state: { error: errorMessage } });
  }
}

function renderStatus({ icon, iconColor, title, message, showCloseButton }) {
  document.body.innerHTML = `
    <div style="display:flex;justify-content:center;align-items:center;height:100vh;flex-direction:column;background:#f8f9fa">
      <div style="color:${iconColor};font-size:48px">${icon}</div>
      <h3>${title}</h3>
      <p style="color:#666">${message}</p>
      ${showCloseButton ? '<button onclick="window.close()" style="padding:8px 16px;margin-top:16px">Close</button>' : ''}
    </div>
  `;
}

export default FacebookCallback;